import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { PawPrint, ArrowRight, SealCheck } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";

export const ArtWorkzBand = () => {
  const [art, setArt] = useState([]);
  const { addItem } = useCart();

  useEffect(() => {
    api.get("/products", { params: { category: "artworkz" } })
      .then(({ data }) => setArt(data.slice(0, 3))).catch(() => {});
  }, []);

  if (art.length === 0) return null;
  const collect = (p) => { addItem(p, 1, {}); toast.success(`${p.slogan} — added to bag 🐾`); };

  return (
    <section className="relative overflow-hidden border-b border-white/10 bg-[#050505]" data-testid="home-artworkz-band">
      <div className="absolute right-0 top-0 h-[26rem] w-[26rem] rounded-full soul-pulse pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(0,229,229,0.3) 0%, rgba(0,229,229,0) 70%)", filter: "blur(14px)" }} />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-9">
          <div>
            <p className="overline text-primary mb-2">Mr. Wigglez ArtWorkz</p>
            <h2 className="font-display font-black uppercase tracking-tighter leading-[0.92] text-4xl sm:text-5xl">
              Collect the art. <span style={{ color: "#ccff00" }}>Fund the ranch.</span>
            </h2>
            <p className="text-muted-foreground mt-3 max-w-lg">Museum-grade canvases that scream for the voiceless. Every piece signed, numbered — and a portion builds Heaven.</p>
          </div>
          <Link to="/artworkz" className="inline-flex items-center gap-2 overline px-5 py-3 rounded-[10px] border border-primary/40 text-primary hover:bg-primary hover:text-primary-foreground transition-colors shrink-0" data-testid="home-artworkz-cta">
            View the collection <ArrowRight size={16} />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="home-artworkz-grid">
          {art.map((p, i) => (
            <motion.div key={p.id} initial={{ opacity: 0, y: 22 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.07 }}
              className="group" data-testid={`home-art-${p.id}`}>
              <div className="relative rounded-lg overflow-hidden bg-black p-3 border-2 border-white/15" style={{ boxShadow: "0 18px 50px rgba(0,0,0,0.6)" }}>
                <Link to="/artworkz">
                  <img src={(p.images || [])[0]} alt={p.name} className="aspect-square w-full object-cover rounded-sm group-hover:scale-[1.04] transition-transform duration-700" />
                </Link>
                {p.exclusivity && (
                  <span className="absolute top-4 left-4 overline px-3 py-1 rounded-full text-black font-semibold" style={{ background: "linear-gradient(90deg,#fbbf24,#d97706)" }}>{p.exclusivity}</span>
                )}
              </div>
              <div className="mt-3 px-1 flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <p className="overline text-muted-foreground inline-flex items-center gap-1.5"><SealCheck weight="fill" size={11} className="text-accent" /> Signed</p>
                  <h3 className="font-display font-black uppercase text-xl leading-tight truncate">{p.slogan}</h3>
                  <span className="text-lg font-modern">${p.price.toLocaleString()}</span>
                </div>
                <button onClick={() => collect(p)} className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-4 py-2.5 rounded-[10px] font-modern hover:bg-primary/90 transition-colors shrink-0" data-testid={`home-art-collect-${p.id}`}>
                  <PawPrint weight="fill" size={15} /> Collect
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ArtWorkzBand;
